// Main layout component
import { ReactNode, useState } from 'react';
import './Layout.css';

interface LayoutProps {
  children: ReactNode;
  storyTitle?: string;
  onSettingsClick?: () => void;
  onAbandon?: () => void;
  onComplete?: () => void;
}

export function Layout({ children, storyTitle, onSettingsClick, onAbandon, onComplete }: LayoutProps) {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="layout">
      <header className="layout-header">
        <div className="header-content">
          <div className="header-title-group">
            <h1 className="header-title">
              <span className="title-bracket">[</span>
              Unwritten
              <span className="title-bracket">]</span>
            </h1>
          </div>
          <div className="header-actions">
            <button 
              className="menu-btn" 
              onClick={() => setMenuOpen(!menuOpen)}
              title="Menu"
            >
              ☰
            </button>
            {menuOpen && (
              <div className="dropdown-menu fade-in">
                <button className="dropdown-item" onClick={() => window.location.reload()}>
                  ↺ New Adventure
                </button>
                {onSettingsClick && (
                  <button 
                    className="dropdown-item" 
                    onClick={() => { onSettingsClick(); setMenuOpen(false); }}
                  >
                    ⚙ Settings
                  </button>
                )}
                {onAbandon && (
                  <button 
                    className="dropdown-item danger" 
                    onClick={() => { onAbandon(); setMenuOpen(false); }}
                  >
                    Abandon Adventure
                  </button>
                )}
                {onComplete && (
                  <button 
                    className="dropdown-item" 
                    onClick={() => { onComplete(); setMenuOpen(false); }}
                  >
                    Complete Adventure
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
      </header>
      <main className="layout-main">
        {children}
      </main>
      <footer className="layout-footer">
        <p className="footer-text">
          Powered by AI • Built with Cloudflare Workers
        </p>
      </footer>
    </div>
  );
}
